import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_DEMARCATE_JUSTIFY_FILTER_REQUEST,
  FETCH_DEMARCATE_JUSTIFY_FILTER_SUCCESS,
  FETCH_DEMARCATE_JUSTIFY_FILTER_ERROR,
  FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_REQUEST,
  FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_SUCCESS,
  FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_ERROR,
  FETCH_DEMARCATE_JUSTIFY_DELETE_REQUEST,
  FETCH_DEMARCATE_JUSTIFY_DELETE_SUCCESS,
  FETCH_DEMARCATE_JUSTIFY_DELETE_ERROR,
} from 'actionTypes'

const INITIAL_LIST_PARAMS = {
  typeJustification: ['request', 'reproval'],
  status: [0, 1],
}

export const fetchDemarcateJustifiesList =
  (token, params = INITIAL_LIST_PARAMS) =>
  (dispatch) => {
    dispatch(fetchDemarcateJustifiesRequest())
    const param = {
      typeJustification: params.typeJustification,
      status: params.status,
    }
    return new Api(token, dispatch)
      .post(API_URL.DEMARCATE_JUSTIFIES_FILTER, param)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(fetchDemarcateJustificationListSuccess(response.data))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchDemarcateJustificationListError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchDemarcateJustifiesSaveAndUpdate =
  (token, params) => (dispatch) => {
    dispatch(fetchSaveAndUpdateDemarcateJustifiesRequest())
    return new Api(token, dispatch)
      .post(API_URL.DEMARCATE_JUSTIFIES_SAVE_AND_UPDATE, params)
      .then(dispatch(showSpinner()))
      .then(() => {
        dispatch(fetchDemarcateJustificationSaveAndUpdateSuccess())
        dispatch(fetchDemarcateJustifiesList(token))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchDemarcateJustificationSaveAndUpdateError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchDemarcateJustifiesDelete = (token, params) => (dispatch) => {
  const { typeJustification, idJustification } = params
  dispatch(fetchDeleteDemarcateJustifiesRequest())
  return new Api(token, dispatch)
    .delete(
      `${API_URL.DEMARCATE_JUSTIFIES_DELETE}/${typeJustification}/${idJustification}`
    )
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(fetchDemarcateJustificationDeleteSuccess())
      dispatch(fetchDemarcateJustifiesList(token))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchDemarcateJustificationDeleteError(error))
      dispatch(hideSpinner())
    })
}

export const fetchDemarcateJustifiesRequest = () => ({
  type: FETCH_DEMARCATE_JUSTIFY_FILTER_REQUEST,
})

export const fetchDemarcateJustificationListSuccess = (data) => ({
  type: FETCH_DEMARCATE_JUSTIFY_FILTER_SUCCESS,
  payload: data,
})

export const fetchDemarcateJustificationListError = (error) => ({
  type: FETCH_DEMARCATE_JUSTIFY_FILTER_ERROR,
  payload: error,
})

export const fetchSaveAndUpdateDemarcateJustifiesRequest = () => ({
  type: FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_REQUEST,
})

export const fetchDemarcateJustificationSaveAndUpdateSuccess = () => ({
  type: FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_SUCCESS,
})

export const fetchDemarcateJustificationSaveAndUpdateError = (error) => ({
  type: FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_ERROR,
  payload: error,
})

// ----- Delete Actions

export const fetchDeleteDemarcateJustifiesRequest = () => ({
  type: FETCH_DEMARCATE_JUSTIFY_DELETE_REQUEST,
})

export const fetchDemarcateJustificationDeleteSuccess = () => ({
  type: FETCH_DEMARCATE_JUSTIFY_DELETE_SUCCESS,
})

export const fetchDemarcateJustificationDeleteError = (error) => ({
  type: FETCH_DEMARCATE_JUSTIFY_DELETE_ERROR,
  payload: error,
})
